import React from 'react';

/* Icons */
import checkIcon from 'symbols/check.svg';

/* Atoms */
import { Icon } from "js/components/atoms";

export default function ConversionFlowSteps({ steps, setStep }) {

    const isStepCompleted = (step) => {
        const activeStep = steps.find((step) => step.active);
        return step.position < activeStep.position;
    }

    const activateStep = (step) => {
        if (isStepCompleted(step)) {
            setStep(step);
        }
    }

    return (
        <div className="flow__steps py-4 py-xl-6 px-0">
            <div className="row gutters-3 gutters-xl-8 flex-nowrap">
                {steps && steps.filter((step) => !step.hidden).map((step) => (
                    <div key={step.id} className="col-auto">
                        <div
                            onClick={() => activateStep(step)}
                            className={`flow__step ${isStepCompleted(step) && 'is-complete'} ${step.active && 'is-active'} ${step.last && 'is-last'}`}
                        >
                            <div className="flow__step-number text-sm">
                                {isStepCompleted(step) ?
                                    (
                                        <Icon url={checkIcon} size={24}  />
                                    )
                                    :
                                    (
                                        <span>{step.position}</span>
                                    )
                                }
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    )
}
